import React from 'react';

import { Footer } from '@bessemercws/components';
import { Outlet } from 'react-router-dom';

import Header from '#/components/Header';
import NewUserWizard from '#/components/VerificationWizard/VerificationWizard';
import { useSetClientIdFromPath } from '#/layouts/hooks/useSetClientIdFromPath';
import { WithHeaderContainer } from '../WithHeader.styles';

/**
 * Alternative layout where the Outlet isn't wrapped in a
 *  `Container` so that custom layout width backgrounds can be achieved
 */
export const CustomBody = () => {
  useSetClientIdFromPath();

  document.title = import.meta.env.VITE_TITLE;

  return (
    <WithHeaderContainer data-testid="with-header">
      <Header className="header" />
      <NewUserWizard />
      <Outlet />
      <Footer className="footer" data-testid="footer-container"></Footer>
    </WithHeaderContainer>
  );
};
